import script from "./ClientDeviceMonitorSystemSettingsAlarmReset.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientDeviceMonitorSystemSettingsAlarmReset.vue?vue&type=script&setup=true&lang=js"

import "./ClientDeviceMonitorSystemSettingsAlarmReset.vue?vue&type=style&index=0&id=5b00eef4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b00eef4"]])

export default __exports__